
<template>
  <div>
    <div class="shareBox">
      分享本文至：
      <span class="hover-pointer" @click="shareToMicroblog()">
      <img style="width: 30px;height: 30px" src="@/assets/img/weibo.png" alt="" />
    </span>
      <span class="qqIcon hover-pointer" >
<!--      <span class="qqIcon hover-pointer" @click="shareToQQRom()">-->
<!--      <img src="@/assets/img/gou.png" alt="" />-->
    </span>
<!--      <span class="hover-pointer" @click="shareToWeChat()">-->
<!--      <img style="width: 30px;height: 30px" src="@/assets/img/weichat.png" alt="" />-->
<!--    </span>-->
      <el-popover
          placement="top-start"
          title="微信扫一扫：分享"
          width="200"
          trigger="hover"

          v-model="visible">
        <div style="background-color: pink;height: 100px;width: 100px;">
          <div style="display: flex;justify-content: center;align-items: center" id="qqq">
            <div id="qrCode" ref="qrCodeDiv"></div>
          </div>
        </div>
        <div style="font-size: 12px">
          <p>微信里点“发现”，扫一下</p>
          <p>二维码便可将本文分享至朋友圈</p>
        </div>

        <el-button style="border: transparent" slot="reference" @mouseenter.native="shareToWeChat" >

          <span class="hover-pointer">
      <img style="width: 30px;height: 30px" src="@/assets/img/weichat.png" alt="" />
    </span>

        </el-button>
      </el-popover>
    </div>
<!--    <div style="background-color: pink;height: 300px;width: 300px">-->
<!--      <div id="qqq">-->
<!--        <div id="qrCode" ref="qrCodeDiv"></div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import QRCode from 'qrcodejs2';
export default {
  props: ["sysInfo"],  //父组件传过来的文章数据
  data() {
    return {
      visible: false,
      url:'',
      shareUrl: location.href,
    };
  },
  methods: {
    /**
     * 分享到微博
     */
    shareToMicroblog() {
      //跳转地址
      window.open(
          "https://service.weibo.com/share/share.php?url=" +
          encodeURIComponent(this.shareUrl) +
          "&title="+
          this.sysInfo
      );
    },
    /**
     * 分享到qq空间
     */
    // shareToQQRom() {
    //   //跳转地址
    //   window.open(
    //       "https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" +
    //       encodeURIComponent(this.shareUrl) +
    //       "&title=" +
    //       this.sysInfo +
    //       "&summary=" +
    //       this.sysInfo
    //   );
    // },
    /**
     * 分享到微信：需要单独画页面
     */
    shareToWeChat() {

      // console.log(111)

      localStorage.setItem("shareUrl", this.shareUrl); // 存储当前页面地址，前端页面直接根据URL链接生成二维码
      // let url = location.href.split("#")[0] + "#/Share/toWechat"; // 注意：#/Share/toWechat: 自己定义的路由
      let url = location.href.split("#")[0] + "#/case"; // 注意：#/Share/toWechat: 自己定义的路由
      // console.log(url)
      this.url=url
      // window.open(url);
      this.generateQRCode();
      this.visible=!this.visible


    },
    // 生成二维码
    bindQRCode: function () {

      // 使用 $nextTick 来确保在下一个 DOM 更新周期执行
      this.$nextTick(() => {
        // 清空 qrCodeDiv 元素内容
        this.$refs.qrCodeDiv.innerHTML = '';

        // 生成新的二维码
        new QRCode(this.$refs.qrCodeDiv, {
          text: this.url,
          width: 250,
          height: 250,
          colorDark: "#333333",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.L
        });
      });
    },
    generateQRCode () {
      this.$nextTick(function () {
        this.bindQRCode();
      })
    },



  },
};
</script>



<style scoped lang="scss">
.shareBox {
  .iconfont {
    font-size: 22px !important;
  }
  .qqIcon {
    display: inline-block;
    margin: 0 10px;
  }
}

</style>